// Service pour les notifications admin (backend)
import api from '../config/api';

export interface Notification {
  id: number;
  type_notification: string;
  type_notification_display?: string;
  recipient_type: string;
  recipient_type_display?: string;
  subject: string;
  message: string;
  html_content: string;
  is_sent: boolean;
  sent_at?: string;
  sent_count?: number;
  recipient_count?: number;
  created_at: string;
  updated_at: string;
}

export interface NotificationStats {
  total: number;
  sent: number;
  pending: number;
  by_type: Record<string, number>;
  active_users?: number;
  total_users?: number;
  members?: number;
  notifications_sent?: number;
  notifications_pending?: number;
  total_notifications?: number;
}

export interface SendNotificationResponse {
  sent_count: number;
  failed_count: number;
  message: string;
}

export const notificationService = {
  // Obtenir les statistiques
  getStats: async (): Promise<NotificationStats> => {
    const response = await api.get('/notifications/stats/');
    return response.data;
  },

  // Obtenir toutes les notifications
  getAll: async (page: number = 1): Promise<{ results: Notification[]; count: number; next?: string; previous?: string }> => {
    const response = await api.get('/notifications/notifications/', { params: { page } });
    return response.data;
  },

  // Obtenir une notification par ID
  getById: async (id: number): Promise<Notification> => {
    const response = await api.get(`/notifications/notifications/${id}/`);
    return response.data;
  },

  // Créer une notification
  create: async (data: Partial<Notification>): Promise<Notification> => {
    const response = await api.post('/notifications/notifications/', data);
    return response.data;
  },

  // Modifier une notification
  update: async (id: number, data: Partial<Notification>): Promise<Notification> => {
    const response = await api.put(`/notifications/notifications/${id}/`, data);
    return response.data;
  },

  // Supprimer une notification
  delete: async (id: number): Promise<void> => {
    await api.delete(`/notifications/notifications/${id}/`);
  },

  // Prévisualiser une notification
  preview: async (id: number): Promise<{ html_content: string }> => {
    const response = await api.get(`/notifications/notifications/${id}/preview/`);
    return response.data;
  },

  // Envoyer une notification
  send: async (id: number, recipientEmails?: string[]): Promise<SendNotificationResponse> => {
    const response = await api.post(`/notifications/notifications/${id}/send/`, {
      recipient_emails: recipientEmails,
    });
    return response.data;
  },
};

export default notificationService;
